<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1oAjjv/tc-custom/9781572844322.jpg?1708805190619" alt="This image is the cover for the book Good Eating's Quick Breads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Eating's Quick Breads
      </h1>
      <p class="bookDescription body article font2">
        <b>A selection of no-fail, simple bread recipes—from muffins to pancakes to sweet and savory loaves from the <i>Chicago Tribune</i>’s award-winning food writers.</b><br/>  <br/><i>Good Eating’s Quick Breads</i> provides a broad selection of quick bread recipes—all of which are made with a leavening agent like baking powder or soda instead of yeast to permit immediate baking—that are easily prepared and always enjoyed.<br/>  <br/> An engaging and helpful introduction to baking quick breads precedes recipes that cover everything from scones, muffins, and pancakes to biscuits, savory loaves, and sweet loaves baked with fruits, nuts, and spices. For those who rarely bake, or even for those who regularly do looking for something new, quick breads are perfect sure-success recipes that can be prepared for any occasion.<br/>  <br/> Written in the friendly tone of the <i>Chicago Tribune</i> and compiled from recipes kitchen-tested by the staff’s award-winning food writers, <i>Good Eating’s Quick Breads</i> is a terrific addition to any home cook’s library. Filled with full-color photographs, helpful hints, and interesting back-stories, this book is a wonderful, straightforward way to add a unique twist to any chef’s repertoire.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chicago Tribune Staff
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Agate Publishing, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49138c48